
import React from 'react';
import { Shield } from 'lucide-react';
import KitTemplate from '@/components/hq/KitTemplate';

const ComplianceKit = () => {
  const sections = {
    downloads: {
      title: "🔹 Downloads",
      description: "Legal documents, forms, and regulatory resources",
      files: [
        { name: "Consent Form Packet", type: "pdf" as const, size: "2.8 MB", placeholder: true },
        { name: "HIPAA Readiness Checklist", type: "pdf" as const, size: "1.4 MB", placeholder: true },
        { name: "NP Credentialing Form", type: "docx" as const, size: "890 KB", placeholder: true },
        { name: "OSHA Safety Checklist", type: "pdf" as const, size: "1.2 MB", placeholder: true }
      ]
    },
    sops: {
      title: "🔸 SOPs",
      description: "Compliance procedures and legal protocols",
      files: [
        { name: "Uploading Provider Credentials", type: "pdf" as const, placeholder: true },
        { name: "Collecting and Storing Patient Forms", type: "pdf" as const, placeholder: true },
        { name: "Incident Reporting Protocol", type: "pdf" as const, placeholder: true },
        { name: "Local Regulatory Compliance Overview", type: "pdf" as const, placeholder: true }
      ]
    },
    training: {
      title: "🎓 Training",
      description: "Compliance education and certification",
      files: [
        { name: "Intro to HIPAA for Medspas", type: "mp4" as const, placeholder: true },
        { name: "OSHA Walkthrough & Safety Rules", type: "mp4" as const, placeholder: true },
        { name: "How to Handle Patient Concerns", type: "pdf" as const, placeholder: true }
      ]
    }
  };

  return (
    <KitTemplate
      kitId="compliance"
      kitTitle="Compliance Kit"
      kitDescription="Credentialing, consent forms, and location requirements - simplified"
      icon={<Shield className="h-6 w-6 text-emerald-400" />}
      sections={sections}
    />
  );
};

export default ComplianceKit;
